import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = true

export { application }
